export const GET_GIFT_EXCHANGE_POINT_ACTION = "GET_GIFT_EXCHANGE_POINT_ACTION";
export const SET_GIFT_EXCHANGE_POINT_ACTION = "SET_GIFT_EXCHANGE_POINT_ACTION";

export const CREATE_ORDER_EXCHANGE_POINT_ACTION =
	"CREATE_ORDER_EXCHANGE_POINT_ACTION";
